/* eslint-disable @typescript-eslint/naming-convention */
export function isBatchItem<
    E extends { __typename: 'BaseLoaderItemError' } | { __typename: '%other' } | { __typename: unknown}
>(
    o: E
): o is Exclude<E, { __typename: 'BaseLoaderItemError' } | { __typename: '%other'}> {
    if (o.__typename === 'BaseLoaderItemError') return false;
    if (o.__typename === '%other') return false;

    return true;
}
